import { GetOneCustomerInDto, GetOneCustomerOutDto } from '../../../types/customer.dto'

export const UPDATE_CURRENT_CUSTOMER = 'UPDATE_CURRENT_CUSTOMER'
export const UPDATE_CURRENT_CUSTOMER_SUCCESS = 'UPDATE_CURRENT_CUSTOMER_SUCCESS'
export const UPDATE_CURRENT_CUSTOMER_ERROR = 'UPDATE_CURRENT_CUSTOMER_ERROR'
export const RESET_UPDATE_CURRENT_CUSTOMER = 'RESET_UPDATE_CURRENT_CUSTOMER'

export interface UpdateCurrentCustomer {
  type: typeof UPDATE_CURRENT_CUSTOMER
  payload: GetOneCustomerOutDto
}

export interface UpdateCurrentCustomerSuccess {
  type: typeof UPDATE_CURRENT_CUSTOMER_SUCCESS
  payload: GetOneCustomerInDto
}

export interface UpdateCurrentCustomerError {
  type: typeof UPDATE_CURRENT_CUSTOMER_ERROR
  payload: string | boolean
}

export interface ResetUpdateCurrentCustomer {
  type: typeof RESET_UPDATE_CURRENT_CUSTOMER
  payload: null
}

export interface State {
  data: GetOneCustomerInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = UpdateCurrentCustomer | UpdateCurrentCustomerSuccess | UpdateCurrentCustomerError | ResetUpdateCurrentCustomer
